<script setup>
import { inject } from "vue";

const bulk_upload_response = inject("bulk_upload_response");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header">
              <h3 class="card-title">INCORRECT DATA</h3>
            </div>
            <div class="card-body" x-data="filter-options">
              <div class="row">
                <label
                  v-if="bulk_upload_response.incorrectData?.length !== 0"
                  style="color: red"
                >
                  {{ bulk_upload_response.incorrectData?.length }}
                  device{{
                    bulk_upload_response.incorrectData?.length === 1 ? "" : "s"
                  }}
                  with incorrect info.
                </label>
                <table
                  v-if="bulk_upload_response.incorrectData?.length !== 0"
                  class="table table-striped"
                >
                  <thead>
                    <tr>
                      <th>ROW NO.</th>
                      <th>IMEI</th>
                      <th>ICCID</th>
                      <th>MSISDN</th>
                      <th>Device Class</th>
                      <th>Device Type</th>
                      <th>Provider</th>
                      <th>Incorrect Info</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="incorrect in bulk_upload_response.incorrectData"
                      :key="incorrect.row"
                    >
                      <td>{{ incorrect.row }}</td>
                      <td>{{ incorrect.imei }}</td>
                      <td>{{ incorrect.iccid }}</td>
                      <td>{{ incorrect.msisdn }}</td>
                      <td>{{ incorrect.device_class }}</td>
                      <td>{{ incorrect.device_type }}</td>
                      <td>{{ incorrect.provider }}</td>
                      <td style="color: red">
                        {{ incorrect.incorrect_info?.replace(/,$/, "") }}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div v-else style="color: green; font-weight: bold">
                  No Incorrect Data
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style></style>
